import { render, staticRenderFns } from "./BillingAddressForm.vue?vue&type=template&id=531760e2&scoped=true"
import script from "./BillingAddressForm.vue?vue&type=script&lang=js"
export * from "./BillingAddressForm.vue?vue&type=script&lang=js"
import style0 from "./BillingAddressForm.vue?vue&type=style&index=0&id=531760e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "531760e2",
  null
  
)

export default component.exports